import SortField from './SortField'
import { withSortField } from './withSortField'

const ConnectedSortField = withSortField(SortField)

export { ConnectedSortField as SortField }
